import styled from "styled-components";

export const Container = styled.div `
    p{
        font-size: 13px;
        color: #B8B8D4;
    }
    h1{
        margin: 0;
        padding: 0;
        font-size: 26px;
    }
    hr{
        height: 1px;
        border: 0;
        background-color: #16195C;
        margin: 30px 0;
    }

    label{
        font-size: 13px;
        display: block;
        margin-bottom: 20px;

    }

    .form-control,.form-select {
        border-radius: 2rem;
        border: 0;
        padding: .9rem 1.3rem;
        background: #efefef;
        box-shadow: inset 7px 7px 14px #cbcbcb,
            inset -7px -7px 14px #ffffff;
    }

    .btn {
        padding: 1rem;
        border-radius: 1.9rem;
        box-shadow:  7px 7px 14px #cbcbcb,
             -7px -7px 14px #ffffff;
    }

    .btn:hover,focus {
        box-shadow: 7px 7px 14px #a1a1a1, -7px -7px 14px #c9c9c9;
    }

    .back {
        border-radius: 1.9rem;
        width: 3rem;
        height: 3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(145deg, #ffffff, #d7d7d7);
box-shadow:  7px 7px 14px #cbcbcb,
             -7px -7px 14px #ffffff;
        color: #555;
    }

    .back:hover,focus {
        background: linear-gradient(145deg, #d7d7d7, #ffffff);
box-shadow:  7px 7px 14px #cbcbcb,
             -7px -7px 14px #ffffff;
    }

    .bodypart {
        padding: 32px 16px;
        height: 626px;
        width: 313px;
        border-radius: 1.9rem;
        box-shadow:  20px 20px 28px #cbcbcb,
             -20px -20px 28px #ffffff;
    }

    .bodymember {
        display: block;
        font-size: .9rem;
        position: absolute;
        border-radius: .9rem;
        padding: 5px;
        background-color: #fff;
        color: #000;
        cursor: pointer;
    }
    .bodymember:hover,focus {
        font-weight: 700;
    }
    .ativo {
        font-weight: 700;
    }
    .tooltipicon {
        font-size: 1.15rem;
        margin-left: 0.25rem;
    }

    #file {
        padding: .35rem;
    }

    #inputGroupFileAddon04 {
        padding: .35rem 1.5rem;
    }

    .img-fluid{
        max-height: 15rem;
        border: 1px solid #efefef;
        border-radius: 0.5rem;
    }
`;